import { flatMap, mapValues, pick } from '@sama/micro-dash';
import { forEach } from 'lodash';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { strictValues } from '../../../cross-team-shared/misc-utils/strict-record';
import { OutputInfoState } from '../../../outputs/annotation/annotation-shared/annotation-providers';
import { ShapeGroupOrderState } from '../../../team-apis/content/content-connector';
import {
  Answer,
  AnswersByName,
} from '../../../team-apis/otterdam/answers/answer';
import { ImageAnnotationOutput } from '../../../team-apis/otterdam/outputs/image-annotation-output';
import { AbstractOutput } from '../../../team-apis/otterdam/outputs/output';
import { PointCloudOutput } from '../../../team-apis/otterdam/outputs/point-cloud-output';
import { VideoOutput } from '../../../team-apis/otterdam/outputs/video-output';
import { getShapeGroupOrderObjectless } from '../../outputs/annotation/annotation-shared/shape-layer-answer-helper';
import { TaskWorkspaceState } from './task-workspace-state';

export function getShapesFromShapeInfo(
  shapeInfoByOutput: TaskWorkspaceState['outputAnnotationInfo'],
) {
  return flatMap(strictValues(shapeInfoByOutput), (shapeInfo) =>
    strictValues(shapeInfo.shapes),
  );
}

export function getShapesRecordFromShapeInfo(
  shapeInfoByOutput: StrictRecord<AbstractOutput['name'], ShapeGroupOrderState>,
) {
  const shapes: StrictRecord<number, ShapeState> = {};
  forEach(shapeInfoByOutput, (shapeInfo) =>
    // @ts-ignore -- fix me
    Object.assign(shapes, shapeInfo.shapes),
  );
  return shapes;
}

export function getShapeInfoFromOutputAnnotationInfo(
  state: StrictRecord<AbstractOutput['name'], OutputInfoState>,
) {
  return mapValues(state, (outputInfo) =>
    pick(outputInfo, 'shapeAndGroupOrder', 'shapes', 'groups'),
  );
}

/** @deprecated used for old projects without objects */
export function buildTrainingShapesObjectless(
  trainingAnswers: AnswersByName | undefined,
  trainingAnswersForOutput: Answer,
  output: PointCloudOutput | VideoOutput | ImageAnnotationOutput,
) {
  return (
    trainingAnswers &&
    getShapeGroupOrderObjectless(trainingAnswersForOutput, output).shapes
  );
}
